export default __webpack_public_path__ + "static/Idea-validation-2cec96e7738b7a51549a3018d955602f.webp";